module.exports = __webpack_public_path__ + "static/media/3.48042155.JPG";